import React, { useId } from 'react';

/** Labelled input. `aside` renders on the label row (e.g. "Forgot password?"). */
export default function TextField({
  label, aside, hint, error, prefix, suffix, className = '', inputClassName = '', id, multiline, ...inputProps
}) {
  const autoId = useId();
  const fieldId = id || autoId;
  return (
    <div className={`field ${className}`}>
      {(label || aside) && (
        <div className="field__head">
          {label && <label className="field__label" htmlFor={fieldId}>{label}</label>}
          {aside}
        </div>
      )}
      {multiline ? (
        <textarea id={fieldId} className={`textarea ${inputClassName}`} {...inputProps} />
      ) : (
        <div className={`input ${error ? 'input--error' : ''}`}>
          {prefix}
          <input id={fieldId} className={`input__control ${inputClassName}`} aria-invalid={!!error} {...inputProps} />
          {suffix}
        </div>
      )}
      {error ? <p className="field__error">{error}</p> : hint && <p className="field__hint">{hint}</p>}
    </div>
  );
}
